export default function() {
    this.initGiveActiveFilter();
}
